import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Checkbox from "../../../components/Checkbox/Checkbox";
import Form from "../../../components/Form/Form";
import FormTitle from "../../../components/FormTitle/FormTitle";
import Input from "../../../components/Input/Input";
import Loader from "../../../components/Loader/Loader";
import RfReceiverForm from "../../../components/RfReceiverForm/RfReceiverForm";
import Select from "../../../components/Select/Select";
import ToggleButton from "../../../components/ToggleButton/ToggleButton";
import { useListManager } from "../../../contexts/list.manager";
import { useUserStore } from "../../../contexts/userStore";
import { ModuleType, ModuleTypeText } from "../../../enums/moduleType";
import AccessModuleService from "../../../services/AccessModuleService";
import "./FormAccessPoints.css";
import { GoArrowSwitch } from "react-icons/go";
import { AccessUnitSelector } from "../../../components/AccessUnitSelector/AccessUnitSelector";
import { useTranslation } from "react-i18next";

function FormAccessPoints(props) {
	const { t } = useTranslation();
	const [position, setPosition] = useState(props.accessPoint?.position);
	const [name, setName] = useState(props.accessPoint?.name);
	const [enabled, setEnabled] = useState(props.accessPoint?.enabled);
	const [addressRs485, setAdressRs485] = useState(
		props.accessPoint?.address_rs485
	);
	const [serialNumber, setSerialNumber] = useState(
		props.accessPoint?.serial_number
	);
	const [mode, setMode] = useState(props.accessPoint?.mode);
	const [time, setTime] = useState(props.accessPoint?.time);
	const [quantity, setQuantity] = useState(props.accessPoint?.quantity);
	const [carAccess, setCarAccess] = useState(props.accessPoint?.car_access);
	const [carUnknownAllowedAccess, setCarUnknownAllowedAccess] = useState(
		props.accessPoint?.car_unknown_allowed_access
	);
	const [output, setOutput] = useState(props.accessPoint?.output);
	const [singleReader, setSingleReader] = useState(
		props.accessPoint?.single_reader
	);
	const [oneWayMode, setOneWayMode] = useState(props.accessPoint?.one_way_mode);
	const [alarmPortOpen, setAlarmPortOpen] = useState(
		props.accessPoint?.alarm_enabled_port_open
	);
	const [timeOpen, setTimeOpen] = useState(props.accessPoint?.time_open);
	const [alarmPeriod, setAlarmPeriod] = useState(
		props.accessPoint?.alarm_period
	);
	const [alarmCalendar, setAlarmCalendar] = useState(
		props.accessPoint?.alarm_calendar
	);

	const [startHour, setStartHour] = useState(props.accessPoint?.start_hour);
	const [endHour, setEndHour] = useState(props.accessPoint?.end_hour);
	const [mondayEnabled, setMondayEnabled] = useState();
	const [tuesdayEnabled, setTuesdayEnabled] = useState();
	const [wednesdayEnabled, setWednesdayEnabled] = useState();
	const [thursdayEnabled, setThursdayEnabled] = useState();
	const [friday, setFridayEnabled] = useState();
	const [saturdayEnabled, setSaturdayEnabled] = useState();
	const [sunday, setSundayEnabled] = useState();
	const [continuousInterval, setContinuousInterval] = useState(
		props.accessPoint?.continuous_interval
	);
	const [delayClosingSensor, setDelayClosingSensor] = useState(
		props.accessPoint?.delay_closing_sensor
	);
	const [panicByTag, setPanicByTag] = useState(props.accessPoint?.panic_by_tag);
	const [uhfReaderFilter, setUhfReaderFilter] = useState(
		props.accessPoint?.UHF_reader_filter
	);
	const [delayReadingSensor, setDelayReadingSensor] = useState(
		props.accessPoint?.reading_delay
	);
	const [sector, setSector] = useState(props.accessPoint?.sector);
	const [warningSound, setWarningSound] = useState(
		props.accessPoint?.warning_sound
	);
	const [includeOpeningInterface, setIncludeOpeningInterface] = useState(
		props.accessPoint?.include_opening_interface
	);
	const [invertReaderCode, setInvertReaderCode] = useState(
		props.accessPoint?.invert_reader_code
	);
	const [wiegandForce26, setWiegandForce26] = useState(
		props.accessPoint?.wiegand_force26
	);
	const [showAdvanced, setShowAdvanced] = useState(false);
	const [showLoader, setShowLoader] = useState(false);
	const [visibleOnMonitoring, setVisibleOnMonitoring] = useState(
		props.accessPoint?.visible_on_monitoring
	);

	const [selectedAccessType, setSelectedAccessType] = useState(
		props.accessType || 0
	);

	const [entryMode, setEntryMode] = useState(
		props.accessPoint?.entry_mode || 0
	);

	const [warningTime, setWarningTime] = useState(
		props.accessPoint?.warning_time
	);

	const [fallingArm, setFallingArm] = useState(props.accessPoint?.bqc || false);
	const [doubleDirection, setDoubleDirection] = useState(
		props.accessPoint?.double_direction || false
	);

	const [boardMode, setBoardMode] = useState(props.accessPoint?.board_mode || 0);

	const [subModules, setSubModules] = useState([
		{
			subId: 1,
			name: "",
			enabled: false,
			mode: 0,
			pulseTime: 0,
			pulseCounter: 0,
			outputs: 0,
			relay1: false,
			relay2: false,
			relay3: false,
			relay4: false,
			alarmEnabled: false,
			alarmTimeout: 0,
			alarmPeriod: 0,
			alarmScheduled: false,
			alarmStartTime: null,
			alarmEndTime: null,
			alarmWeek: [],
			alarmWeekFull: false,
			uuid: null,
			autolock: false,
			closeDelay: 0,
			monitor: false,
			vehicle: false,
			vehicleUnknownAllowed: false,
			direction: 0,
			readDelay: delayReadingSensor,
			panicEnabled: panicByTag,
			sector: '',
		},
		{
			subId: 2,
			name: "",
			enabled: false,
			mode: 0,
			pulseTime: 0,
			pulseCounter: 0,
			outputs: 0,
			relay1: false,
			relay2: false,
			relay3: false,
			relay4: false,
			alarmEnabled: false,
			alarmTimeout: 0,
			alarmPeriod: 0,
			alarmScheduled: false,
			alarmStartTime: null,
			alarmEndTime: null,
			alarmWeek: [],
			alarmWeekFull: false,
			uuid: null,
			autolock: false,
			closeDelay: 0,
			monitor: false,
			vehicle: false,
			vehicleUnknownAllowed: false,
			direction: 0,
			readDelay: delayReadingSensor,
			panicEnabled: panicByTag,
			sector: '',
		},
		{
			subId: 3,
			name: "",
			enabled: false,
			mode: 0,
			pulseTime: 0,
			pulseCounter: 0,
			outputs: 0,
			relay1: false,
			relay2: false,
			relay3: false,
			relay4: false,
			alarmEnabled: false,
			alarmTimeout: 0,
			alarmPeriod: 0,
			alarmScheduled: false,
			alarmStartTime: null,
			alarmEndTime: null,
			alarmWeek: [],
			alarmWeekFull: false,
			uuid: null,
			autolock: false,
			closeDelay: 0,
			monitor: false,
			vehicle: false,
			vehicleUnknownAllowed: false,
			direction: 0,
			readDelay: delayReadingSensor,
			panicEnabled: panicByTag,
			sector: '',
		},
		{
			subId: 4,
			name: "",
			enabled: false,
			mode: 0,
			pulseTime: 0,
			pulseCounter: 0,
			outputs: 0,
			relay1: false,
			relay2: false,
			relay3: false,
			relay4: false,
			alarmEnabled: false,
			alarmTimeout: 0,
			alarmPeriod: 0,
			alarmScheduled: false,
			alarmStartTime: null,
			alarmEndTime: null,
			alarmWeek: [],
			alarmWeekFull: false,
			uuid: null,
			autolock: false,
			closeDelay: 0,
			monitor: false,
			vehicle: false,
			vehicleUnknownAllowed: false,
			direction: 0,
			readDelay: delayReadingSensor,
			panicEnabled: panicByTag,
			sector: '',
		},
	]);

	const [uuid, setUuid] = useState();
	const [entryUnitUuid, setEntryUnitUuid] = useState();
	const [exitUnitUuid, setExitUnitUuid] = useState();

	const { selectedCondominio, selectedLicenceObj } = useUserStore();
	const { closeForm } = useListManager();

	useEffect(() => {
		const ap = props.accessPoint;
		if (!ap) return;

		setSelectedAccessType(ap.type);
		setName(ap.name);
		setEnabled(ap.enabled);
		setUuid(ap.uuid);
		setEntryUnitUuid(ap.entry_ref);
		setExitUnitUuid(ap.exit_ref);

		switch (ap.type) {
			case ModuleType.NativeDoor:
			case ModuleType.DoorModule:
			case ModuleType.IpDoorModule: {
				const key =
					ap.type === ModuleType.NativeDoor
						? "localDoor"
						: ap.type === ModuleType.DoorModule
							? "door"
							: "doorIp";
				const d = ap[key];

				setAdressRs485(ap.address ? String(ap.address) : "");
				setSerialNumber(ap.serial ? String(ap.serial) : "");
				setSelectedAccessType(ap.type);
				if (d) {
					setPosition(String(d.position));
					setEnabled(d.enabled);
					setIncludeOpeningInterface(d.includeOpeningInterface);
					setSector(d.sector);
					setSingleReader(d.exitReader);
					setEntryMode(String(d.entryMode));
					setMode(String(d.mode));
					setTime(String(d.pulseTime));
					setQuantity(String(d.pulseCounter));
					setAlarmPortOpen(d.alarmEnabled);
					setTimeOpen(String(d.alarmTimeout));
					setAlarmPeriod(String(d.alarmPeriod));
					setAlarmCalendar(d.alarmScheduled);
					setStartHour(d.alarmStartTime);
					setEndHour(d.alarmEndTime);
					const week = (d.alarmWeek || "").split(",");
					setSundayEnabled(week.includes("Sunday"));
					setMondayEnabled(week.includes("Monday"));
					setTuesdayEnabled(week.includes("Tuesday"));
					setWednesdayEnabled(week.includes("Wednesday"));
					setThursdayEnabled(week.includes("Thursday"));
					setFridayEnabled(week.includes("Friday"));
					setSaturdayEnabled(week.includes("Saturday"));
					setContinuousInterval(d.alarmWeekFull);
					setDelayClosingSensor(String(d.closeDelay));
					setPanicByTag(d.panicTagEnabled);
					setUhfReaderFilter(d.uhfEnabled);
					setDelayReadingSensor(String(d.uhfDelay));
					setWarningSound(String(d.buzzer));
					setVisibleOnMonitoring(d.monitor);
					setCarAccess(d.vehicle);
					setInvertReaderCode(d.lsb);
					setWiegandForce26(d.w26);
					setWarningTime(String(d.buzzerTimeout));
					setCarUnknownAllowedAccess(d.vehicleUnknownAllowed);
				}
				break;
			}

			case ModuleType.IpParkModule: {
				const p = ap.parkIp;
				setBoardMode(p.boardMode);
				setSerialNumber(ap.serial ? String(ap.serial) : "");
				setSelectedAccessType(ap.type);
				if (p) {
					setPosition(String(p.position));
					setEnabled(p.enabled);
					setIncludeOpeningInterface(p.includeOpeningInterface);
					setSector(p.sector);
					setSingleReader(p.exitReader);
					setEntryMode(String(p.entryMode));
					setMode(String(p.mode));
					setTime(String(p.pulseTime));
					setQuantity(String(p.pulseCounter));
					setTimeOpen(String(p.alarmTimeout));
					setDelayClosingSensor(String(p.closeDelay));
					setPanicByTag(p.panicTagEnabled);
					setUhfReaderFilter(p.uhfEnabled);
					setDelayReadingSensor(String(p.uhfDelay));
					setWarningSound(String(p.buzzer));
					setVisibleOnMonitoring(p.monitor);
					setInvertReaderCode(p.lsb);
					setWiegandForce26(p.w26);
					setWarningTime(String(p.buzzerTimeout));
				}
				break;
			}

			case ModuleType.RfReceiverModule:
			case ModuleType.IpRfReceiverModule: {
				const g =
					ap[ap.type === ModuleType.RfReceiverModule ? "garage" : "garageIp"];
				setAdressRs485(String(ap.address) || "");
				setSerialNumber(String(ap.serial) || "");
				setDelayReadingSensor(String(g.readDelay));
				setPanicByTag(g.panicEnabled);
				setSubModules(ap.subModules);
				break;
			}

			case ModuleType.TurnstileModule:
			case ModuleType.IpTurnstileModule: {
				const key = ap.type === ModuleType.TurnstileModule ? "gate" : "gateIp";
				const t = ap[key];

				setAdressRs485(String(ap.address) || "");
				setSerialNumber(String(ap.serial) || "");
				setMode(String(t.mode));
				setTime(String(t.pulseTime));
				setSector(t.sector);
				setEnabled(t.enabled);
				setEntryMode(String(t.entryMode));
				setSingleReader(t.singleRelay);
				setPanicByTag(t.panicTagEnabled);
				setVisibleOnMonitoring(t.monitor);
				setOutput(t.freeOut);
				setFallingArm(t.bqc);
				setOneWayMode(t.tourniquetSingleSide);
				setInvertReaderCode(t.lsb);
				setWiegandForce26(t.w26);
				setDoubleDirection(t.doubleDirection);
				setUuid(t.uuid);
				break;
			}

			case ModuleType.KioskIpModule: {
				const k = ap["kioskIp"];
				setSerialNumber(String(ap.serial) || "");
				setEnabled(k.enabled);
				setUuid(k.uuid);
				break;
			}

			case ModuleType.EdgeAiIpModule: {
				const e = ap["edgeAiIp"];
				setSerialNumber(String(ap.serial) || "");
				setEnabled(e.enabled);
				setUuid(e.uuid);
				break;
			}

			default:
				break;
		}
	}, [props.accessPoint]);

	const navigate = useNavigate();

	const buildPayload = () => {
		let payload = {
			id_condominium: selectedCondominio,
			licenceId: selectedLicenceObj.id,
			type: selectedAccessType,
			name: name,
			address: parseInt(addressRs485),
			serial: serialNumber,
			entry_ref: entryUnitUuid,
			exit_ref: exitUnitUuid,
		};

		if (
			// props.formMode === "edicao" &&
			selectedAccessType === ModuleType.NativeDoor
		) {
			payload.localDoorData = {
				name: name,
				position: parseInt(position) ? parseInt(position) : 1,
				enabled: enabled,
				mode: parseInt(mode) ? parseInt(mode) : 0,
				pulseTime: parseInt(time) ? parseInt(time) : 0,
				pulseCounter: parseInt(quantity) ? parseInt(quantity) : 0,
				alarmEnabled: alarmPortOpen || false,
				alarmTimeout: parseInt(timeOpen) ? parseInt(timeOpen) : 0,
				alarmPeriod: parseInt(alarmPeriod) ? parseInt(alarmPeriod) : 0,
				alarmScheduled: alarmCalendar || false,
				alarmStartTime: startHour,
				alarmEndTime: endHour,
				alarmWeek: [
					sunday ? "Sunday" : null,
					mondayEnabled ? "Monday" : null,
					tuesdayEnabled ? "Tuesday" : null,
					wednesdayEnabled ? "Wednesday" : null,
					thursdayEnabled ? "Thursday" : null,
					friday ? "Friday" : null,
					saturdayEnabled ? "Saturday" : null,
				]
					.filter(Boolean)
					.join(","),
				alarmWeekFull: continuousInterval || false,
				exitReader: singleReader || false,
				uuid: uuid,
				autolock: continuousInterval || false,
				closeDelay: parseInt(delayClosingSensor)
					? parseInt(delayClosingSensor)
					: 0,
				panicTagEnabled: panicByTag || false,
				uhfEnabled: uhfReaderFilter || false,
				uhfDelay: parseInt(delayReadingSensor)
					? parseInt(delayReadingSensor)
					: 0,
				buzzer: parseInt(warningSound) ? parseInt(warningSound) : 0,
				monitor: visibleOnMonitoring || false,
				vehicle: carAccess || false,
				lsb: invertReaderCode || false,
				w26: wiegandForce26 || false,
				buzzerTimeout: parseInt(warningTime) ? parseInt(warningTime) : 0,
				vehicleUnknownAllowed: carUnknownAllowedAccess || false,
				sector,
			};
		} else {
			switch (selectedAccessType) {
				case ModuleType.DoorModule:
					payload.doorData = {
						name: name,
						enabled: enabled || false,
						mode: parseInt(mode) ? parseInt(mode) : 0,
						pulseTime: parseInt(time) ? parseInt(time) : 0,
						pulseCounter: parseInt(quantity) ? parseInt(quantity) : 0,
						alarmEnabled: alarmPortOpen || false,
						alarmTimeout: parseInt(timeOpen) ? parseInt(timeOpen) : 0,
						alarmPeriod: parseInt(alarmPeriod) ? parseInt(alarmPeriod) : 0,
						alarmScheduled: alarmCalendar || false,
						alarmStartTime: startHour || null,
						alarmEndTime: endHour || null,
						alarmWeek: [
							sunday ? "Sunday" : null,
							mondayEnabled ? "Monday" : null,
							tuesdayEnabled ? "Tuesday" : null,
							wednesdayEnabled ? "Wednesday" : null,
							thursdayEnabled ? "Thursday" : null,
							friday ? "Friday" : null,
							saturdayEnabled ? "Saturday" : null,
						]
							.filter(Boolean)
							.join(","),
						alarmWeekFull: continuousInterval || false,
						uuid: uuid,
						closeDelay: parseInt(delayClosingSensor)
							? parseInt(delayClosingSensor)
							: 0,
						panicTagEnabled: panicByTag || false,
						uhfEnabled: uhfReaderFilter || false,
						uhfDelay: parseInt(delayReadingSensor)
							? parseInt(delayReadingSensor)
							: 0,
						buzzer: parseInt(warningSound) ? parseInt(warningSound) : 0,
						monitor: visibleOnMonitoring,
						vehicle: carAccess || false,
						lsb: invertReaderCode || false,
						w26: wiegandForce26 || false,
						buzzerTimeout: parseInt(warningTime) ? parseInt(warningTime) : 0,
						vehicleUnknownAllowed: carUnknownAllowedAccess,
						sector,
					};
					break;
				case ModuleType.IpDoorModule:
					payload.doorIpData = {
						name: name,
						enabled: enabled || false,
						mode: parseInt(mode) ? parseInt(mode) : 0,
						pulseTime: parseInt(time),
						pulseCounter: parseInt(quantity),
						alarmEnabled: alarmPortOpen || false,
						alarmTimeout: parseInt(timeOpen),
						alarmPeriod: parseInt(alarmPeriod),
						alarmScheduled: alarmCalendar || false,
						alarmStartTime: startHour,
						alarmEndTime: endHour,
						alarmWeek: [
							sunday ? "Sunday" : null,
							mondayEnabled ? "Monday" : null,
							tuesdayEnabled ? "Tuesday" : null,
							wednesdayEnabled ? "Wednesday" : null,
							thursdayEnabled ? "Thursday" : null,
							friday ? "Friday" : null,
							saturdayEnabled ? "Saturday" : null,
						]
							.filter(Boolean)
							.join(","),
						alarmWeekFull: continuousInterval || false,
						uuid: uuid,
						closeDelay: parseInt(delayClosingSensor),
						panicTagEnabled: panicByTag || false,
						uhfEnabled: uhfReaderFilter || false,
						uhfDelay: parseInt(delayReadingSensor),
						buzzer: parseInt(warningSound),
						monitor: !!visibleOnMonitoring,
						vehicle: carAccess || false,
						lsb: invertReaderCode || false,
						w26: wiegandForce26 || false,
						buzzerTimeout: parseInt(warningTime),
						vehicleUnknownAllowed: carUnknownAllowedAccess || false,
						sector,
					};
					break;
				case ModuleType.IpParkModule:
					payload.parkIpData = {
						name: name,
						boardMode: parseInt(boardMode),
						enabled: enabled || false,
						mode: parseInt(mode) ? parseInt(mode) : 0,
						pulseTime: parseInt(time),
						pulseCounter: parseInt(quantity),
						uuid: uuid,
						closeDelay: parseInt(delayClosingSensor),
						panicTagEnabled: panicByTag || false,
						uhfEnabled: uhfReaderFilter || false,
						uhfDelay: parseInt(delayReadingSensor),
						monitor: !!visibleOnMonitoring,
						lsb: invertReaderCode || false,
						w26: wiegandForce26 || false,
						sector,
					};
					break;
				case ModuleType.RfReceiverModule:
					payload.garageData = {
						subModules: subModules.map((sub) => ({
							subId: sub.subId,
							name: sub.name || "",
							enabled: sub.enabled || false,
							mode: Number(sub.mode) || 0,
							pulseTime: Number(sub.pulseTime) || 0,
							pulseCounter: Number(sub.pulseCounter) || 0,
							outputs: Number(sub.outputs) || 0,
							relay1: !!sub.relay1,
							relay2: !!sub.relay2,
							relay3: !!sub.relay3,
							relay4: !!sub.relay4,
							alarmEnabled: !!sub.alarmEnabled,
							alarmTimeout: Number(sub.alarmTimeout) || 0,
							alarmPeriod: Number(sub.alarmPeriod) || 0,
							alarmScheduled: !!sub.alarmScheduled,
							alarmStartTime: sub.alarmStartTime || null,
							alarmEndTime: sub.alarmEndTime || null,
							alarmWeek: Array.isArray(sub.alarmWeek) ? sub.alarmWeek?.filter(d => ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"].includes(d)).join(",") : [],
							alarmWeekFull: !!sub.alarmWeekFull,
							uuid: sub.uuid || null,
							autolock: !!sub.autolock,
							closeDelay: Number(sub.closeDelay) || 0,
							monitor: !!sub.monitor,
							vehicle: !!sub.vehicle,
							vehicleUnknownAllowed: !!sub.vehicleUnknownAllowed,
							direction: Number(sub.direction) || 0,
							readDelay: Number(sub.readDelay) || 0,
							panicEnabled: !!sub.panicEnabled,
							sector: sub.sector,
						})),
						readDelay: Number(delayReadingSensor) || 0,
						panicEnabled: !!panicByTag,
						sector,
					};
					break;

				case ModuleType.IpRfReceiverModule:
					payload.garageIpData = {
						subModules: subModules.map((sub) => ({
							subId: sub.subId,
							name: sub.name || "",
							enabled: sub.enabled || false,
							mode: Number(sub.mode) || 0,
							pulseTime: Number(sub.pulseTime) || 0,
							pulseCounter: Number(sub.pulseCounter) || 0,
							outputs: Number(sub.outputs) || 0,
							relay1: !!sub.relay1,
							relay2: !!sub.relay2,
							relay3: !!sub.relay3,
							relay4: !!sub.relay4,
							alarmEnabled: !!sub.alarmEnabled,
							alarmTimeout: Number(sub.alarmTimeout) || 0,
							alarmPeriod: Number(sub.alarmPeriod) || 0,
							alarmScheduled: !!sub.alarmScheduled,
							alarmStartTime: sub.alarmStartTime || null,
							alarmEndTime: sub.alarmEndTime || null,
							alarmWeek: Array.isArray(sub.alarmWeek) ? sub.alarmWeek?.filter(d => ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"].includes(d)).join(",") : [],
							alarmWeekFull: !!sub.alarmWeekFull,
							uuid: sub.uuid || null,
							autolock: !!sub.autolock,
							closeDelay: Number(sub.closeDelay) || 0,
							monitor: !!sub.monitor,
							vehicle: !!sub.vehicle,
							vehicleUnknownAllowed: !!sub.vehicleUnknownAllowed,
							direction: Number(sub.direction) || 0,
							readDelay: Number(sub.readDelay) || 0,
							panicEnabled: !!sub.panicEnabled,
							sector: sub.sector,
						})),
						readDelay: Number(delayReadingSensor) || 0,
						panicEnabled: !!panicByTag,
					};
					break;

				case ModuleType.TurnstileModule:
					payload.gateData = {
						name: name || null,
						enabled: enabled || false,
						mode: parseInt(mode) || 0,
						pulseTime: parseInt(time) || 0,
						entryMode: parseInt(entryMode) || 0,
						uuid: uuid || null,
						sector,
						singleRelay: singleReader || false,
						panicTagEnabled: panicByTag || false,
						monitor: visibleOnMonitoring || false,
						freeOut: output || false,
						bqc: fallingArm || false,
						tourniquetSingleSide: oneWayMode || false,
						lsb: invertReaderCode || false,
						w26: wiegandForce26 || false,
						doubleDirection: doubleDirection || false,
					};
					break;
				case ModuleType.IpTurnstileModule:
					payload.gateIpData = {
						name: name || null,
						enabled: enabled || false,
						mode: parseInt(mode) || 0,
						pulseTime: parseInt(time) || 0,
						entryMode: parseInt(entryMode) || 0,
						uuid: uuid || null,
						singleRelay: singleReader || false,
						panicTagEnabled: panicByTag || false,
						monitor: visibleOnMonitoring || false,
						freeOut: output || false,
						bqc: fallingArm || false,
						tourniquetSingleSide: oneWayMode || false,
						lsb: invertReaderCode || false,
						w26: wiegandForce26 || false,
						doubleDirection: doubleDirection || false,
						sector,
					};
					break;

				case ModuleType.KioskIpModule:
					payload.kioskIpData = {
						name: name || null,
						enabled: enabled || false,
						uuid: uuid || null,
					};
					break;

				case ModuleType.EdgeAiIpModule:
					payload.edgeAiIpData = {};
					break;

				default:
					console.warn("Tipo de módulo não reconhecido:", selectedAccessType);
			}
		}

		return payload;
	};

	async function handleSubmit(event) {
		event.preventDefault();
		if (props.formMode === "edicao") {
			handleEdit();
			return;
		}
		setShowLoader(true);
		const payload = buildPayload();
		const response = await AccessModuleService.createAccessModule(payload);
		setShowLoader(false);
		if (response.data.id) navigate("../consulta-access-points", {
			state: { refresh: true }
		});
	}

	async function handleEdit() {
		setShowLoader(true);
		const payload = buildPayload();
		const response = await AccessModuleService.updateAccessModule(
			props.accessPoint.id,
			payload
		);
		setShowLoader(false);
		if (response.data.id) navigate("../consulta-access-points");
	}

	async function handleDelete() {
		if (!props.accessPoint) return;
		setShowLoader(true);
		await AccessModuleService.deleteAccessModule(props.accessPoint.id);
		setShowLoader(false);
		closeForm();
		navigate("../consulta-access-points", {
			state: { deletedId: props.accessPoint.id },
		});
	}

	const handleClickEditButton = () => {
		if (!props.accessPoint) return;
		navigate(`/access-points/${props.accessPoint?.uuid}`, { state: props.accessPoint });
	};

	const handleChangeSelectAccessType = (event) => {
		const selectedValue = event.target.value;
		setSelectedAccessType(Number(selectedValue));
		setShowAdvanced(false);
		const NUM_SUBMODULES = 4;
		setSubModules(
			Array.from({ length: NUM_SUBMODULES }, (_, idx) => ({
				subId: idx + 1,
				name: "",
				enabled: false,
				mode: 0,
				pulseTime: 0,
				pulseCounter: 0,
				outputs: 0,
				relay1: false,
				relay2: false,
				relay3: false,
				relay4: false,
				alarmEnabled: false,
				alarmTimeout: 0,
				alarmPeriod: 0,
				alarmScheduled: false,
				alarmStartTime: null,
				alarmEndTime: null,
				alarmWeek: [],
				alarmWeekFull: false,
				uuid: null,
				autolock: false,
				closeDelay: 0,
				monitor: false,
				vehicle: false,
				vehicleUnknownAllowed: false,
				direction: 0,
				readDelay: false,
				panicEnabled: false,
				sector: null,
			}))
		);
	};

	function getSingleReaderText() {
		if (selectedAccessType === 0) {
			if (position === 2) return t("equipment.activateDoor1");
			if (position === 4) return t("equipment.activateDoor3");
		}

		return t("equipment.singleReaderUsers");
	}

	function getSingleReaderLabel() {
		if (selectedAccessType === 0) {
			if (Number(position) === 2) return t("equipment.activateDoor1");
			if (Number(position) === 4) return t("equipment.activateDoor3");
		}

		return t("equipment.singleReader");
	}

	return (
		<React.Fragment>
			<FormTitle
				type={props.formMode}
				icon={<GoArrowSwitch size={20} />}
				tituloConsulta={props.accessPoint?.name || null}
				tituloCadastro={
					selectedAccessType in ModuleTypeText
						? t("equipment.accessRegistrationType", { type: t(ModuleTypeText[selectedAccessType]) })
						: t("equipment.accessRegistration")
				}
				backRoute={"/consulta-access-points"}
			/>

			{showLoader ? (
				<Loader />
			) : (
				<Form
					type={props.formMode}
					navigateCancelUrl="../consulta-access-points"
					handleSubmit={handleSubmit}
					handleClickEdit={handleClickEditButton}
					handleDelete={handleDelete}
					deleteButNotSynqed={props.accessPoint?.deletedAt ? true : false}
					saveDisabled={selectedAccessType === ""}
				>
					<React.Fragment>
						<div className="group-of-inputs-type-container">
							<div className="select-access-type">
								<Select
									labelText={
										props.formMode === "consulta"
											? t("equipment.accessType")
											: t("equipment.selectAccessType")
									}
									name="accessPointType"
									id="accessPointType"
									value={selectedAccessType + 1}
									disabled={props.formMode !== "cadastro"}
									onChange={({ target }) =>
										handleChangeSelectAccessType({
											target: { value: target.value - 1 },
										})
									}
									options={[
										...Object.entries(ModuleTypeText).map(
											([key, text]) => ({
												value: Number(key) + 1,
												text: t(text),
											})
										),
									]}
								/>
							</div>
						</div>

						{selectedAccessType !== null &&
							[
								ModuleType.RfReceiverModule,
								ModuleType.IpRfReceiverModule,
							].includes(selectedAccessType) && (
								<div className="container-rf-receiver">
									<div className="container-address-rf-receiver">
										{[ModuleType.IpRfReceiverModule].includes(
											selectedAccessType
										) ? (
											<Input
												name="serial_number"
												id="serial_number"
												labelText={t(
													"equipment.serialIdentifier"
												)}
												value={serialNumber}
												onChange={({ target }) =>
													setSerialNumber(target.value)
												}
												disabled={props.formMode === "consulta"}
												required={true}
												tooltipVisible={
													props.formMode !== "consulta"
												}
												tooltipText={t(
													"equipment.ipModuleSerialTooltip"
												)}
											/>
										) : (
											<Input
												name="address_rs485"
												id="address_rs485"
												labelText={t(
													"equipment.rs485Address"
												)}
												value={addressRs485}
												onChange={({ target }) =>
													setAdressRs485(target.value)
												}
												disabled={
													props.formMode === "consulta" ||
													props.formMode === "edicao"
												}
												required={selectedAccessType !== 3}
												hidden={
													selectedAccessType === 3 ||
													props.formMode === "consulta"
												}
												tooltipVisible={
													props.formMode !== "consulta"
												}
												tooltipText={t(
													"equipment.rs485AddressTooltip"
												)}
											/>
										)}

										<Input
											name="reading_delay"
											id="reading_delay"
											type="number"
											labelText={t("equipment.readingDelay")}
											value={delayReadingSensor}
											onChange={({ target }) =>
												setDelayReadingSensor(target.value)
											}
											disabled={props.formMode === "consulta"}
											hidden={props.formMode === "consulta"}
											required={false}
											tooltipText={t("equipment.readingDelayTooltip")}
											tooltipVisible={true}
										/>

										<ToggleButton
											label={t("equipment.enablePanic")}
											name="panic_by_tag"
											id="panic_by_tag"
											defaultChecked={panicByTag}
											selected={panicByTag}
											onChange={({ target }) =>
												setPanicByTag(target.checked)
											}
											required={false}
											minWidthLabel="170px"
											disabled={props.formMode === "consulta"}
											tooltipText={t(
												"equipment.panicByTagTooltip"
											)}
											tooltipVisible={true}
											hidden={props.formMode === "consulta"}
										/>
									</div>

									<RfReceiverForm
										subModuleIndex={
											props.accessPoint?.subModuleIndex || 0
										}
										subModules={subModules}
										setSubModules={setSubModules}
										formMode={props.formMode}
										accessType={selectedAccessType}
									/>
								</div>
							)}

						{selectedAccessType !== null &&
							![
								ModuleType.RfReceiverModule,
								ModuleType.IpRfReceiverModule,
							].includes(selectedAccessType) ? (
							<div className="container-config-access">
								<div className="group-of-inputs-access-container">
									<Input
										name="name"
										id="name"
										labelText={t("equipment.name")}
										value={name}
										onChange={({ target }) =>
											setName(target.value)
										}
										disabled={props.formMode === "consulta"}
										required={true}
										tooltipVisible={props.formMode !== "consulta"}
										tooltipText={t("equipment.nameTooltip")}
									/>

									{selectedAccessType !== ModuleType.NativeDoor && (
										<>
											{[
												ModuleType.IpDoorModule,
												ModuleType.IpRfReceiverModule,
												ModuleType.IpTurnstileModule,
												ModuleType.IpParkModule,
												ModuleType.KioskIpModule,
												ModuleType.EdgeAiIpModule,
											].includes(selectedAccessType) ? (
												<Input
													name="serial_number"
													id="serial_number"
													labelText={t(
														"equipment.serialIdentifier"
													)}
													value={serialNumber}
													onChange={({ target }) =>
														setSerialNumber(target.value)
													}
													disabled={
														props.formMode === "consulta"
													}
													required={true}
													tooltipVisible={
														props.formMode !== "consulta"
													}
													tooltipText={t(
														"equipment.ipModuleSerialTooltip"
													)}
												/>
											) : (
												<Input
													name="address_rs485"
													id="address_rs485"
													labelText={t(
														"equipment.rs485Address"
													)}
													value={addressRs485}
													onChange={({ target }) =>
														setAdressRs485(target.value)
													}
													disabled={
														props.formMode === "consulta" ||
														props.formMode === "edicao"
													}
													required={selectedAccessType !== 3}
													hidden={selectedAccessType === 3}
													tooltipVisible={
														props.formMode !== "consulta"
													}
													tooltipText={t(
														"equipment.rs485AddressTooltip"
													)}
												/>
											)}
										</>
									)}

									<Select
										labelText={t("equipment.position")}
										name="position"
										id="position"
										value={position}
										onChange={({ target }) =>
											setPosition(target.value)
										}
										disabled={
											props.formMode === "consulta" ||
											props.formMode === "edicao"
										}
										required={selectedAccessType === 0}
										options={[
											{
												value: 1,
												text: t("equipment.position1"),
											},
											{
												value: 2,
												text: t("equipment.position2"),
											},
											{
												value: 3,
												text: t("equipment.position3"),
											},
											{
												value: 4,
												text: t("equipment.position4"),
											},
										]}
										hidden={selectedAccessType !== 0}
										tooltipVisible={
											props.formMode !== "consulta"
										}
										tooltipText={t(
											"equipment.positionTooltip"
										)}
									/>

									<Select
										labelText={t("equipment.mode")}
										name="mode"
										id="mode"
										value={mode}
										onChange={({ target }) =>
											setMode(target.value)
										}
										disabled={props.formMode === "consulta"}
										required={
											[ModuleType.KioskIpModule].includes(
												selectedAccessType
											)
												? false
												: true
										}
										hidden={[
											ModuleType.KioskIpModule,
										].includes(selectedAccessType)}
										options={[
											{
												value: 1,
												text: t("equipment.pulse"),
											},
											{
												value: 2,
												text: t("equipment.toggle"),
											},
										]}
										tooltipVisible={
											props.formMode !== "consulta"
										}
										tooltipText={t("equipment.modeTooltip")}
									/>

									<Input
										name="time"
										id="time"
										labelText={t("equipment.time")}
										type="number"
										value={time}
										onChange={({ target }) =>
											setTime(target.value)
										}
										disabled={props.formMode === "consulta"}
										required={
											[ModuleType.KioskIpModule].includes(
												selectedAccessType
											)
												? false
												: true
										}
										hidden={[
											ModuleType.KioskIpModule,
										].includes(selectedAccessType)}
										tooltipVisible={
											props.formMode !== "consulta"
										}
										tooltipText={t(
											"equipment.timeTooltip"
										)}
									/>

									{mode == 1 && (
										<Input
											name="quantity"
											id="quantity"
											labelText={t(
												"equipment.quantity"
											)}
											type="number"
											value={quantity}
											onChange={({ target }) =>
												setQuantity(target.value)
											}
											disabled={
												props.formMode === "consulta"
											}
											required={
												selectedAccessType === 14 ||
													selectedAccessType === 8
													? false
													: true
											}
											hidden={
												selectedAccessType === 14 ||
												selectedAccessType === 8
											}
											tooltipVisible={
												props.formMode !== "consulta"
											}
											tooltipText={t(
												"equipment.quantityTooltip"
											)}
										/>
									)}
								</div>
							</div>
						) : null}
					</React.Fragment>

					{props.formMode !== "consulta" &&
						selectedAccessType !== null &&
						![
							ModuleType.RfReceiverModule,
							ModuleType.IpRfReceiverModule,
							ModuleType.KioskIpModule,
							ModuleType.EdgeAiIpModule,
						].includes(selectedAccessType) && (
							<div className="grid-2">
								<AccessUnitSelector
									label={t("common.entry")}
									unitId={entryUnitUuid}
									setUnitId={setEntryUnitUuid}
									scopedUnitId={selectedCondominio}
									type={props.formMode}
								/>

								<AccessUnitSelector
									label={t("common.exit")}
									unitId={exitUnitUuid}
									setUnitId={setExitUnitUuid}
									scopedUnitId={selectedCondominio}
									type={props.formMode}
								/>
							</div>
						)}

					{selectedAccessType != null &&
						![
							ModuleType.RfReceiverModule,
							ModuleType.IpRfReceiverModule,
						].includes(selectedAccessType) ? (
						<>
							<div
								className={`grid w-full gap-2 ${selectedAccessType === ModuleType.IpParkModule
									? "grid-cols-2"
									: "grid-cols-1"
									}`}
							>
								{selectedAccessType ===
									ModuleType.IpParkModule && (
										<Select
											labelText={t("common.type")}
											name="boardMode"
											id="boardMode"
											value={boardMode}
											onChange={({ target }) =>
												setBoardMode(target.value)
											}
											disabled={
												props.formMode === "consulta"
											}
											required={true}
											options={[
												{
													value: 0,
													text: `${t("common.entry")} (${t(
														"equipment.ticket"
													)})`,
												},
												{
													value: 1,
													text: `${t("common.exit")} (${t(
														"equipment.reader"
													)})`,
												},
											]}
											hidden={
												selectedAccessType !== 16
											}
											tooltipText={t(
												"equipment.operationModeTooltip"
											)}
											tooltipVisible={true}
										/>
									)}

								<div
									className="group-toggle-button"
									style={{
										marginTop: "5px",
										justifyContent: "left",
										width: "100%",
										gap: "20px",
										flexWrap: "wrap",
										flexDirection: "row",
										alignItems: "center",
									}}
								>
									<ToggleButton
										name="enabled"
										id="enabled"
										label={
											enabled
												? t("common.enabled")
												: t("common.disabled")
										}
										defaultChecked={enabled}
										selected={enabled}
										onChange={({ target }) =>
											setEnabled(target.checked)
										}
										required={false}
										disabled={
											props.formMode === "consulta"
										}
										tooltipText={t(
											"equipment.enableAccessTooltip"
										)}
										tooltipVisible={true}
										hidden={
											props.formMode === "consulta"
										}
									/>

									{![
										ModuleType.IpParkModule,
										ModuleType.KioskIpModule,
										ModuleType.EdgeAiIpModule,
									].includes(selectedAccessType) && (
											<>
												<ToggleButton
													name="car_access"
													id="car_access"
													label={t(
														"equipment.vehicleAccess"
													)}
													defaultChecked={carAccess}
													selected={carAccess}
													onChange={({ target }) =>
														setCarAccess(target.checked)
													}
													required={false}
													disabled={
														props.formMode === "consulta"
													}
													hidden={
														selectedAccessType === 8 ||
														selectedAccessType === 14 ||
														props.formMode === "consulta"
													}
													tooltipText={t(
														"equipment.vehicleAccessTooltip"
													)}
													tooltipVisible={true}
												/>

												<ToggleButton
													name="car_unknown_allowed_access"
													id="car_unknown_allowed_access"
													label={t(
														"equipment.unlinkedVehicleAccess"
													)}
													defaultChecked={
														carUnknownAllowedAccess
													}
													selected={
														carUnknownAllowedAccess
													}
													onChange={({ target }) =>
														setCarUnknownAllowedAccess(
															target.checked
														)
													}
													required={false}
													disabled={
														props.formMode === "consulta"
													}
													hidden={
														selectedAccessType === 8 ||
														selectedAccessType === 14 ||
														props.formMode === "consulta"
													}
													tooltipText={t(
														"equipment.unlinkedVehicleAccessTooltip"
													)}
													tooltipVisible={true}
												/>
											</>
										)}

									<ToggleButton
										name="visible_on_monitoring"
										id="visible_on_monitoring"
										label={t(
											"equipment.visibleOnMonitoring"
										)}
										defaultChecked={visibleOnMonitoring}
										selected={visibleOnMonitoring}
										onChange={({ target }) =>
											setVisibleOnMonitoring(
												target.checked
											)
										}
										required={false}
										hidden={
											props.formMode === "consulta" ||
											[
												ModuleType.KioskIpModule,
												ModuleType.EdgeAiIpModule,
											].includes(selectedAccessType)
										}
										disabled={
											props.formMode === "consulta"
										}
										tooltipText={t(
											"equipment.visibleOnMonitoringTooltip"
										)}
										tooltipVisible={true}
									/>
								</div>
							</div>
						</>
					) : null}

					{props.formMode !== "consulta" &&
						selectedAccessType !== null &&
						![
							ModuleType.RfReceiverModule,
							ModuleType.IpRfReceiverModule,
						].includes(selectedAccessType) ? (
						<div
							className="advanced-settings-checkbox"
							style={{ marginTop: "10px" }}
						>
							<Checkbox
								labelText={t(
									"equipment.advancedSettings"
								)}
								checked={showAdvanced}
								minWidthLabel="170px"
								highlighted={true}
								onChange={({ target }) =>
									setShowAdvanced(target.checked)
								}
								required={false}
								disabled={
									props.formMode === "consulta"
								}
							/>
						</div>
					) : null}

					{showAdvanced &&
						selectedAccessType !== null &&
						![
							ModuleType.RfReceiverModule,
							ModuleType.IpRfReceiverModule,
						].includes(selectedAccessType) ? (
						<div
							className={`advanced-container ${[
								ModuleType.KioskIpModule,
								ModuleType.EdgeAiIpModule,
							].includes(selectedAccessType)
								? "w-full!"
								: ""
								}`}
						>
							{![
								ModuleType.IpParkModule,
								ModuleType.KioskIpModule,
								ModuleType.EdgeAiIpModule,
							].includes(selectedAccessType) && (
									<>
										<div className="container-advanced-settings">
											<div className="group-of-inputs-advanced-container">
												<Input
													name="time_open"
													id="time_open"
													labelText={t(
														"equipment.openTime"
													)}
													type="number"
													value={timeOpen}
													onChange={({ target }) =>
														setTimeOpen(target.value)
													}
													disabled={
														props.formMode ===
														"consulta" ||
														!alarmPortOpen
													}
													required={false}
													hidden={
														selectedAccessType === 8 ||
														selectedAccessType === 14
													}
												/>

												<Input
													name="alarm_period"
													id="alarm_period"
													labelText={t(
														"equipment.alarmPeriod"
													)}
													type="number"
													value={alarmPeriod}
													onChange={({ target }) =>
														setAlarmPeriod(target.value)
													}
													disabled={
														props.formMode ===
														"consulta" ||
														!alarmPortOpen
													}
													required={false}
													hidden={
														selectedAccessType === 8 ||
														selectedAccessType === 14
													}
												/>
											</div>

											<div className="group-of-checkboxes-advanced-container">
												<ToggleButton
													label={t(
														"equipment.enableOpenDoorAlarm"
													)}
													name="alarm_enabled_port_open"
													id="alarm_enabled_port_open"
													minWidthLabel="170px"
													defaultChecked={alarmPortOpen}
													selected={alarmPortOpen}
													onChange={({ target }) =>
														setAlarmPortOpen(
															target.checked
														)
													}
													required={false}
													disabled={
														props.formMode === "consulta"
													}
													hidden={
														selectedAccessType === 8 ||
														selectedAccessType === 14
													}
												/>

												<ToggleButton
													label={t(
														"equipment.enableAlarmCalendar"
													)}
													name="alarm_calendar"
													id="alarm_calendar"
													minWidthLabel="170px"
													defaultChecked={alarmCalendar}
													selected={alarmCalendar}
													onChange={({ target }) =>
														setAlarmCalendar(
															target.checked
														)
													}
													required={false}
													disabled={
														props.formMode === "consulta"
													}
													hidden={
														selectedAccessType === 8 ||
														selectedAccessType === 14
													}
												/>
											</div>
										</div>

										{!(
											selectedAccessType === 8 ||
											selectedAccessType === 14
										) && (
												<div
													className="container-advanced-date-time"
													style={{
														opacity:
															alarmCalendar &&
																alarmPortOpen
																? "1"
																: "0.3",
														pointerEvents:
															alarmCalendar &&
																alarmPortOpen
																? "auto"
																: "none",
														cursor:
															alarmCalendar &&
																alarmPortOpen
																? "pointer"
																: "not-allowed",
													}}
												>
													<div className="date-time-group-access-point">
														<div className="date-time-container">
															<h3 className="box-title">
																{t(
																	"equipment.timeAndDates"
																)}
															</h3>

															<div className="date-time-grid">
																<Input
																	name="start_hour"
																	id="start_hour"
																	type="time"
																	min="00:00"
																	max="23:59"
																	labelText={t(
																		"equipment.startTime"
																	)}
																	value={startHour}
																	onChange={({ target }) =>
																		setStartHour(
																			target.value
																		)
																	}
																	disabled={
																		props.formMode ===
																		"consulta" ||
																		!(
																			alarmCalendar &&
																			alarmPortOpen
																		)
																	}
																	required={false}
																	tooltipText={t(
																		"equipment.accessGroupStartTimeTooltip"
																	)}
																	tooltipVisible={true}
																	hidden={
																		selectedAccessType ===
																		"turnstile"
																	}
																/>

																<Input
																	name="end_hour"
																	id="end_hour"
																	type="time"
																	min="00:00"
																	max="23:59"
																	labelText={t(
																		"equipment.endTime"
																	)}
																	value={endHour}
																	onChange={({ target }) =>
																		setEndHour(
																			target.value
																		)
																	}
																	disabled={
																		props.formMode ===
																		"consulta" ||
																		!(
																			alarmCalendar &&
																			alarmPortOpen
																		)
																	}
																	required={false}
																	tooltipText={t(
																		"equipment.accessGroupEndTimeTooltip"
																	)}
																	tooltipVisible={true}
																	hidden={
																		selectedAccessType ===
																		8 ||
																		selectedAccessType ===
																		14
																	}
																/>
															</div>

															<div className="container-interval-checkbox">
																<Checkbox
																	labelText={t(
																		"equipment.continuousInterval"
																	)}
																	name="continuous_interval"
																	id="continuous_interval"
																	defaultChecked={
																		continuousInterval
																	}
																	onChange={({ target }) =>
																		setContinuousInterval(
																			target.checked
																		)
																	}
																	required={false}
																	inputWidth="200px"
																	minWidthLabel="120px"
																	disabled={
																		props.formMode ===
																		"consulta" ||
																		!(
																			alarmCalendar &&
																			alarmPortOpen
																		)
																	}
																/>
															</div>
														</div>
													</div>

													<div
														className="group-of-inputs-date-container-access-point"
														style={{
															display:
																selectedAccessType !== 8 ||
																	selectedAccessType !== 14
																	? "block"
																	: "none",
														}}
													>
														<p className="group-of-inputs-title">
															{t(
																"equipment.activeWeekdays"
															)}
														</p>

														<div className="checkbox-container">
															<Checkbox
																labelText={t(
																	"common.sunday"
																)}
																defaultChecked={sunday}
																onChange={({ target }) =>
																	setSundayEnabled(
																		target.checked
																	)
																}
																required={false}
																minWidthLabel="120px"
																disabled={
																	props.formMode ===
																	"consulta" ||
																	!(
																		alarmCalendar &&
																		alarmPortOpen
																	)
																}
															/>

															<Checkbox
																labelText={t(
																	"common.monday"
																)}
																defaultChecked={
																	mondayEnabled
																}
																onChange={({ target }) =>
																	setMondayEnabled(
																		target.checked
																	)
																}
																required={false}
																minWidthLabel="120px"
																disabled={
																	props.formMode ===
																	"consulta" ||
																	!(
																		alarmCalendar &&
																		alarmPortOpen
																	)
																}
															/>

															<Checkbox
																labelText={t(
																	"common.tuesday"
																)}
																defaultChecked={
																	tuesdayEnabled
																}
																onChange={({ target }) =>
																	setTuesdayEnabled(
																		target.checked
																	)
																}
																required={false}
																minWidthLabel="120px"
																disabled={
																	props.formMode ===
																	"consulta" ||
																	!(
																		alarmCalendar &&
																		alarmPortOpen
																	)
																}
															/>

															<Checkbox
																labelText={t(
																	"common.wednesday"
																)}
																defaultChecked={
																	wednesdayEnabled
																}
																onChange={({ target }) =>
																	setWednesdayEnabled(
																		target.checked
																	)
																}
																required={false}
																minWidthLabel="120px"
																disabled={
																	props.formMode ===
																	"consulta" ||
																	!(
																		alarmCalendar &&
																		alarmPortOpen
																	)
																}
															/>

															<Checkbox
																labelText={t(
																	"common.thursday"
																)}
																defaultChecked={
																	thursdayEnabled
																}
																onChange={({ target }) =>
																	setThursdayEnabled(
																		target.checked
																	)
																}
																required={false}
																minWidthLabel="120px"
																disabled={
																	props.formMode ===
																	"consulta" ||
																	!(
																		alarmCalendar &&
																		alarmPortOpen
																	)
																}
															/>

															<Checkbox
																labelText={t(
																	"common.friday"
																)}
																defaultChecked={friday}
																onChange={({ target }) =>
																	setFridayEnabled(
																		target.checked
																	)
																}
																required={false}
																minWidthLabel="120px"
																disabled={
																	props.formMode ===
																	"consulta" ||
																	!(
																		alarmCalendar &&
																		alarmPortOpen
																	)
																}
															/>

															<Checkbox
																labelText={t(
																	"common.saturday"
																)}
																defaultChecked={
																	saturdayEnabled
																}
																onChange={({ target }) =>
																	setSaturdayEnabled(
																		target.checked
																	)
																}
																required={false}
																minWidthLabel="120px"
																disabled={
																	props.formMode ===
																	"consulta" ||
																	!(
																		alarmCalendar &&
																		alarmPortOpen
																	)
																}
															/>
														</div>
													</div>
												</div>
											)}
									</>
								)}

							<div className="container-footer-config">
								<div className="group-of-inputs-footer-config">
									{![
										ModuleType.IpParkModule,
										ModuleType.KioskIpModule,
										ModuleType.EdgeAiIpModule,
									].includes(selectedAccessType) && (
											<>
												<Select
													labelText={t(
														"equipment.ledBuzzer"
													)}
													name="warning_sound"
													id="warning_sound"
													value={
														warningSound
															? warningSound
															: 0
													}
													onChange={({ target }) =>
														setWarningSound(
															target.value
														)
													}
													disabled={
														props.formMode === "consulta"
													}
													required={false}
													options={[
														{
															value: 0,
															text: t("common.disabled"),
														},
														{
															value: 1,
															text: t(
																"equipment.waitOpenMag"
															),
														},
														{
															value: 2,
															text: t(
																"equipment.waitOpenLock"
															),
														},
														{
															value: 3,
															text: t(
																"equipment.alarm"
															),
														},
														{
															value: 4,
															text: t(
																"equipment.openDoor"
															),
														},
														{
															value: 5,
															text: t(
																"equipment.unlockedDoor"
															),
														},
														{
															value: 6,
															text: t(
																"equipment.time"
															),
														},
													]}
													hidden={
														selectedAccessType === 8 ||
														selectedAccessType === 14 ||
														selectedAccessType === 2 ||
														selectedAccessType === 13
													}
													tooltipText={t(
														"equipment.warningSoundTooltip"
													)}
													tooltipVisible={true}
												/>

												<Input
													name="warning_time"
													id="warning_time"
													labelText={t(
														"equipment.warningTime"
													)}
													type="number"
													value={warningTime}
													onChange={({ target }) =>
														setWarningTime(
															target.value
														)
													}
													disabled={
														props.formMode === "consulta"
													}
													hidden={
														selectedAccessType === 8 ||
														selectedAccessType === 14 ||
														selectedAccessType === 2 ||
														selectedAccessType === 13
													}
													required={false}
													tooltipText={t(
														"equipment.warningTimeTooltip"
													)}
													tooltipVisible={true}
												/>

												<Input
													name="delay_closing_sensor"
													id="delay_closing_sensor"
													type="number"
													labelText={t(
														"equipment.closingSensorDelay"
													)}
													value={delayClosingSensor}
													onChange={({ target }) =>
														setDelayClosingSensor(
															target.value
														)
													}
													disabled={
														props.formMode === "consulta"
													}
													required={false}
													hidden={
														selectedAccessType === 8 ||
														selectedAccessType === 14
													}
													tooltipText={t(
														"equipment.closingSensorDelayTooltip"
													)}
													tooltipVisible={true}
												/>
											</>
										)}

									<Input
										name="reading_delay"
										id="reading_delay"
										type="number"
										labelText={t(
											"equipment.readingDelay"
										)}
										value={delayReadingSensor}
										onChange={({ target }) =>
											setDelayReadingSensor(
												target.value
											)
										}
										disabled={
											props.formMode === "consulta" ||
											!uhfReaderFilter
										}
										required={false}
										hidden={
											selectedAccessType === 8 ||
											selectedAccessType === 14 ||
											[
												ModuleType.KioskIpModule,
												ModuleType.EdgeAiIpModule,
											].includes(selectedAccessType)
										}
										tooltipText={t(
											"equipment.readingDelayTooltip"
										)}
										tooltipVisible={true}
									/>

									<Input
										name="sector"
										id="sector"
										type="text"
										labelText={t("equipment.sector")}
										value={sector}
										onChange={({ target }) =>
											setSector(target.value)
										}
										disabled={
											props.formMode === "consulta"
										}
										required={false}
										hidden={[
											ModuleType.KioskIpModule,
											ModuleType.EdgeAiIpModule,
										].includes(selectedAccessType)}
										tooltipText={t(
											"equipment.sectorTooltip"
										)}
										tooltipVisible={true}
									/>

									<Input
										name="UUID"
										id="UUID"
										labelText={t("equipment.uuid")}
										value={uuid}
										onChange={({ target }) =>
											setUuid(target.value)
										}
										tooltipText={t(
											"equipment.uuidTooltip"
										)}
										tooltipVisible={true}
									/>
								</div>

								{![
									ModuleType.KioskIpModule,
									ModuleType.EdgeAiIpModule,
								].includes(selectedAccessType) && (
										<div className="group-of-checkboxes-footer-config">
											<ToggleButton
												name="double_direction"
												id="double_direction"
												label={t(
													"equipment.doubleDirection"
												)}
												defaultChecked={doubleDirection}
												selected={doubleDirection}
												onChange={({ target }) =>
													setDoubleDirection(
														target.checked
													)
												}
												required={false}
												hidden={[
													ModuleType.IpParkModule,
												].includes(selectedAccessType)}
												disabled={
													props.formMode === "consulta"
												}
												tooltipText={t(
													"equipment.doubleDirectionTooltip"
												)}
												tooltipVisible={true}
											/>

											<ToggleButton
												name="bqc"
												id="bqc"
												label={t(
													"equipment.fallingArm"
												)}
												defaultChecked={fallingArm}
												selected={fallingArm}
												onChange={({ target }) =>
													setFallingArm(target.checked)
												}
												required={false}
												disabled={
													props.formMode === "consulta"
												}
												hidden={
													!(
														selectedAccessType === 8 ||
														selectedAccessType === 14
													)
												}
												tooltipText={t(
													"equipment.fallingArmTooltip"
												)}
												tooltipVisible={true}
											/>

											<ToggleButton
												name="output"
												id="output"
												label={t(
													"equipment.freeExit"
												)}
												defaultChecked={output}
												selected={output}
												onChange={({ target }) =>
													setOutput(target.checked)
												}
												required={false}
												disabled={
													props.formMode === "consulta"
												}
												hidden={
													!(
														selectedAccessType === 8 ||
														selectedAccessType === 14
													)
												}
												tooltipText={t(
													"equipment.freeExitTooltip"
												)}
												tooltipVisible={true}
											/>

											<ToggleButton
												label={getSingleReaderLabel()}
												name="single_reader"
												id="single_reader"
												minWidthLabel="170px"
												defaultChecked={singleReader}
												selected={singleReader}
												onChange={({ target }) =>
													setSingleReader(
														target.checked
													)
												}
												required={false}
												disabled={
													props.formMode === "consulta"
												}
												hidden={
													![
														8,
														14,
														selectedAccessType === 0 &&
															[2, 4].includes(
																parseInt(position)
															)
															? 0
															: null,
													].includes(selectedAccessType)
												}
												tooltipText={getSingleReaderText()}
												tooltipVisible={true}
											/>

											<ToggleButton
												label={t(
													"equipment.singleTurnstileDirection"
												)}
												name="one_way_mode"
												id="one_way_mode"
												minWidthLabel="170px"
												defaultChecked={oneWayMode}
												selected={oneWayMode}
												onChange={({ target }) =>
													setOneWayMode(
														target.checked
													)
												}
												required={false}
												disabled={
													props.formMode === "consulta"
												}
												hidden={
													!(
														selectedAccessType === 8 ||
														selectedAccessType === 14
													)
												}
												tooltipText={t(
													"equipment.singleTurnstileDirectionTooltip"
												)}
												tooltipVisible={true}
											/>

											<ToggleButton
												label={t(
													"equipment.panicByTag"
												)}
												name="panic_by_tag"
												id="panic_by_tag"
												defaultChecked={panicByTag}
												selected={panicByTag}
												onChange={({ target }) =>
													setPanicByTag(
														target.checked
													)
												}
												required={false}
												minWidthLabel="170px"
												disabled={
													props.formMode === "consulta"
												}
												tooltipText={t(
													"equipment.panicByTagTooltip"
												)}
												tooltipVisible={true}
											/>

											<ToggleButton
												label={t(
													"equipment.includeOpeningInterface"
												)}
												name="include_opening_interface"
												id="include_opening_interface"
												defaultChecked={
													includeOpeningInterface
												}
												selected={
													includeOpeningInterface
												}
												onChange={({ target }) =>
													setIncludeOpeningInterface(
														target.checked
													)
												}
												required={false}
												minWidthLabel="190px"
												disabled={
													props.formMode === "consulta"
												}
												tooltipText={t(
													"equipment.includeOpeningInterfaceTooltip"
												)}
												tooltipVisible={true}
											/>

											<ToggleButton
												label={t(
													"equipment.invertReaderCode"
												)}
												name="invert_reader_code"
												id="invert_reader_code"
												defaultChecked={
													invertReaderCode
												}
												selected={
													invertReaderCode
												}
												onChange={({ target }) =>
													setInvertReaderCode(
														target.checked
													)
												}
												required={false}
												minWidthLabel="190px"
												disabled={
													props.formMode === "consulta"
												}
												hidden={
													selectedAccessType === 2 ||
													selectedAccessType === 13
												}
												tooltipText={t(
													"equipment.invertReaderCodeTooltip"
												)}
												tooltipVisible={true}
											/>

											<ToggleButton
												label={t(
													"equipment.forceWiegand26"
												)}
												name="wiegand_force26"
												id="wiegand_force26"
												defaultChecked={
													wiegandForce26
												}
												selected={
													wiegandForce26
												}
												onChange={({ target }) =>
													setWiegandForce26(
														target.checked
													)
												}
												required={false}
												minWidthLabel="190px"
												disabled={
													props.formMode === "consulta"
												}
												hidden={
													selectedAccessType === 2 ||
													selectedAccessType === 13
												}
												tooltipText={t(
													"equipment.forceWiegand26Tooltip"
												)}
												tooltipVisible={true}
											/>

											<ToggleButton
												label={t(
													"equipment.uhfReaderFilter"
												)}
												name="UHF_reader_filter"
												id="UHF_reader_filter"
												defaultChecked={
													uhfReaderFilter
												}
												selected={
													uhfReaderFilter
												}
												onChange={({ target }) =>
													setUhfReaderFilter(
														target.checked
													)
												}
												required={false}
												minWidthLabel="170px"
												disabled={
													props.formMode === "consulta"
												}
												hidden={
													selectedAccessType === 8 ||
													selectedAccessType === 14 ||
													selectedAccessType === 2 ||
													selectedAccessType === 13
												}
												tooltipText={t(
													"equipment.uhfReaderFilterTooltip"
												)}
												tooltipVisible={true}
											/>
										</div>
									)}
							</div>
						</div>
					) : null}
				</Form>
			)}
		</React.Fragment>
	);
}

export default FormAccessPoints;
